import ApiModule from './index'
import BaseModel from '../../base/BaseModel'

export class GetShopDetail extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/shop/getShopDetail'
		this.desc = '根据商铺id获取商铺详细信息'
	}
}

export class QueryTerminalList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/terminal/queryTerminalList'
		this.desc = '根据机场获取航站楼'
	}
}

export class QueryFilterTerminalList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/terminal/queryFilterTerminalList'
		this.desc = '机场大屏根据机场获取航站楼'
	}
}

export class LvGouWxAppInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/sysconfig/lvGouWxAppInfo'
		this.desc = '中免日上小程序跳转参数'
	}
}

export class QueryAllGroupFlightCityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/city/queryAllGroupFlightCityList'
		this.desc = '查询国际, 境内开通航班城市'
		this.params.request = {
			...props,
			cityId: 0,
			countryId: 0,
			provinceId: 0,
		}
	}

	dataformat(data) {
		super.dataformat(data)

		const externalCity =
			((data.resultData || []).find((it) => it.internal) || {}).groupCityList || []
		const internalCity =
			((data.resultData || []).find((it) => !it.internal) || {}).groupCityList || []

		return {
			internal: internalCity,
			external: externalCity,
		}
	}
}

export class QueryLikeFlightCityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/city/queryLikeFlightCityList'
		this.desc = '根据城市名称城市,首字母模糊查询'
	}
	dataformat(data) {
		super.dataformat(data)
		return data.resultData || []
	}
}
export class QueryLikeAllCityList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/city/queryLikeAllCityList'
		this.desc = '根据城市名称城市,首字母模糊查询'
	}
	dataformat(data) {
		super.dataformat(data)
		return data.resultData || []
	}
}

export class GetDefParkingInfo extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/parking/getDefParkingInfo'
		this.desc = '获取默认停车场信息'
	}
}

export class GetPageMarkList extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/common/getPageMarkList'
		this.desc = '获取页面标记列表'
	}

	dataformat(data) {
		super.dataformat(data)
		return (data.resultData || {}).markList || []
	}
}

export class QueryLocationAirPort extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/airport/queryLocationAirPort'
		this.desc = '获取机场定位信息'
	}
}

export class GetCityByAirportCode extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/city/getCityByAirportCode'
		this.desc = '获取机场所在信息'
	}
}

export class QueryAirPortGroup extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/airport/queryAirPortGroup'
		this.desc = '查询机场分组'
	}

	dataformat(data) {
		super.dataformat(data)
		return data.resultData || []
	}
}

export class SearchAirPort extends BaseModel {
	constructor(props = {}) {
		super(props)
		this.apiModule = ApiModule.BASICINF
		this.url = '/airport/searchAirPort'
		this.desc = '关键词搜索机场'
	}

	dataformat(data) {
		super.dataformat(data)
		return (data.resultData || []).map((it) => ({
			...it,
			airportName: it.webShortName,
		}))
	}
}
